<template>
  <span>
    A user with this email already exists.<br>
    <router-link
      :to="{ name: 'password-reset' }"
      class="reset-link"
    >
      Click here to reset your password</router-link>
  </span>
</template>

<style lang="less" scoped>
.reset-link {
  font-weight: 500;
}
</style>
